import React, { useEffect, useState } from 'react';
import { Save, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { masterclassApi, errorMessage } from '../masterclasses/api';
import { FusionLocationFields } from './FusionLocationFields';

export const FusionMetadataEditor = ({ doc, onSaved, onDirtyChange, disabled }) => {
  const [value, setValue] = useState({ title: doc.title, module: doc.module, submodule: doc.submodule });
  const [version, setVersion] = useState(doc.metadata_version || 0);
  const [dirty, setDirty] = useState(false), [busy, setBusy] = useState(false), [error, setError] = useState('');
  const [taxonomyReady, setTaxonomyReady] = useState(false);
  useEffect(() => {
    if (!dirty) { setValue({ title: doc.title, module: doc.module, submodule: doc.submodule }); setVersion(doc.metadata_version || 0); }
  }, [doc.title, doc.module, doc.submodule, doc.metadata_version, dirty]);
  const save = async event => {
    event.preventDefault(); setBusy(true); setError('');
    try {
      const { data } = await masterclassApi.patch(`/admin/interactive-lessons/${doc.id}/metadata`, { ...value, metadata_version: version });
      onSaved(data); setVersion(data.metadata_version); setDirty(false); onDirtyChange(false);
    } catch (err) { setError(errorMessage(err)); }
    finally { setBusy(false); }
  };
  return <details className="fusion-metadata-editor" data-testid="fusion-metadata-editor">
    <summary data-testid="fusion-metadata-toggle">Nombre y ubicación en Masterclasses</summary>
    <form onSubmit={save} data-testid="fusion-metadata-form">
      <FusionLocationFields value={value} onChange={next => { setValue(next); setDirty(true); onDirtyChange(true); }} disabled={disabled || busy} prefix="fusion-metadata" onReady={setTaxonomyReady} />
      {error && <p className="fusion-error" role="alert" data-testid="fusion-metadata-error">{error}</p>}
      <Button type="submit" disabled={!dirty || disabled || busy || !taxonomyReady} data-testid="fusion-metadata-save">{busy ? <Loader2 className="animate-spin" size={16} /> : <Save size={16} />}Guardar ubicación</Button>
      {dirty && <Button type="button" variant="ghost" disabled={busy} data-testid="fusion-metadata-cancel" onClick={() => { setDirty(false); onDirtyChange(false); setError(''); }}>Cancelar cambios</Button>}
    </form>
  </details>;
};